module.exports = __webpack_public_path__ + "static/media/eye.5629df18.svg";